import React, {useMemo, useCallback} from 'react'
import {removeNode, reorder, selectNode, updateNode} from '../../../../editorActions'
import {NodesList} from './NodesList'
import NodePropertiesToolbox from './NodePropertiesToolbox'

const SidebarPanel = ({state, dispatch, onOpenRemoveBg}) => {
    const selection = state?.selection || {nodeIds: []}

    const nodes = useMemo(() => {
        if (!state) return []
        const order = state.order || []
        const map = state.nodes
        if (!map) return []
        return order.map((id) => map.get(id)).filter(Boolean)
    }, [state])

    const selectedNodeIds = selection?.nodeIds || []
    const selectedNode = selectedNodeIds.length === 1 ? nodes.find((n) => n.id === selectedNodeIds[0]) : null

    const onReorder = useCallback(
        (nodeId, toIndex) => {
            dispatch(reorder(nodeId, toIndex))
        },
        [dispatch],
    )

    const onSelectNode = useCallback(
        (nodeId) => {
            dispatch(selectNode(nodeId, false))
        },
        [dispatch],
    )

    const onRemoveNode = useCallback(
        (nodeId) => {
            dispatch(removeNode(nodeId))
        },
        [dispatch],
    )

    const onToggleNodeLock = useCallback(
        (nodeId, locked) => {
            dispatch(updateNode(nodeId, {state: {locked}}))
        },
        [dispatch],
    )

    const renderNodeDetails = useCallback(
        (node) => {
            if (!selectedNode || selectedNode.id !== node.id) return null

            return <NodePropertiesToolbox node={node} dispatch={dispatch} inline onRemoveBackground={onOpenRemoveBg} />
        },
        [dispatch, onOpenRemoveBg, selectedNode],
    )

    return (
        <section className="SidebarPanel" aria-label="Layers">
            <header className="SidebarPanel__Header">
                <h2 className="SidebarPanel__Title">Layers</h2>
            </header>
            <div className="SidebarPanel__Content">
                <NodesList
                    nodes={nodes}
                    selectedNodeIds={selectedNodeIds}
                    onSelectNode={onSelectNode}
                    onRemoveNode={onRemoveNode}
                    onToggleNodeLock={onToggleNodeLock}
                    onReorder={onReorder}
                    renderNodeDetails={renderNodeDetails}
                />
            </div>
        </section>
    )
}

export default SidebarPanel
